import { createContext, ComponentChildren } from 'preact';
import { useContext, useCallback, useState } from 'preact/hooks';

interface FocusContextType {
  shouldFocus: boolean;
  setFocusOnNextView: () => void;
  resetFocus: () => void;
}

const FocusContext = createContext<FocusContextType>({
  shouldFocus: false,
  setFocusOnNextView: () => undefined,
  resetFocus: () => undefined,
});

interface FocusProviderProps {
  children: ComponentChildren;
}

export const FocusProvider = ({ children }: FocusProviderProps) => {
  const [shouldFocus, setShouldFocus] = useState(false);

  const setFocusOnNextView = useCallback(() => {
    setShouldFocus(true);
  }, []);

  const resetFocus = useCallback(() => {
    setShouldFocus(false);
  }, []);

  return (
    <FocusContext.Provider
      value={{
        shouldFocus,
        setFocusOnNextView,
        resetFocus,
      }}
    >
      {children}
    </FocusContext.Provider>
  );
};

export const useFocus = () => {
  const context = useContext(FocusContext);
  if (!context) {
    throw new Error('useFocus must be used within a FocusProvider');
  }
  return context;
};
